import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/tema-nove.css';
import { nacitajTemu, pouziTemu } from './utils/tema';
import App from './App';

// Vzhľad sa nastaví ešte pred vykreslením, nech appka neblikne klasickým.
pouziTemu(nacitajTemu());

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

